export default "__VITE_ASSET__CbsPfm58__"